import { EvaluatorToEvaluateeRole, RoleParts } from '../../commonTypes/evaluation/evaluator-impact.types';

export function mapRole(role: EvaluatorToEvaluateeRole): RoleParts {
    const [evaluator, evaluatee] = role.split('__').map(part => part.toLowerCase());

    if (!evaluatee) {
        return { evaluator, evaluatee: evaluator };
    }

    return { evaluator, evaluatee };
}

export function displayRoles(role: EvaluatorToEvaluateeRole): string {
    const [evaluator, evaluatee] = role.split('__');

    const format = (str?: string) =>
        (str ?? '')
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b\w/g, c => c.toUpperCase());

    const safeEvaluatee = evaluatee ?? evaluator;

    return `${format(evaluator)} to ${format(safeEvaluatee)}`;
}

export function mapStatus(status: string): string {
    return status
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
